<template>
  <tab-content-layout title="TRANSFERÊNCIA">
    <b-row class="v-clean mb-3">
      <b-col>
        <b-row>
          <b-col>
            <h4 class="title-pages">ORIGEM</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-select-default
              label="RESIDENTES ATIVO/INATIVO"
              :items="[
                { id: null, name: 'TODOS' },
                { id: 'ATIVO', name: 'ATIVO' },
                { id: 'INATIVO', name: 'INATIVO' },
              ]"
              @change="getResidents"
              v-model="status_resident"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="PROPRIETÁRIO"
              :items="residents"
              @change="getStockedItems"
              v-model="origin_resident_id"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="GRUPO"
              :items="origin_groups"
              @change="getStockedItems"
              v-model="origin_group_id"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-select-default
              label="TIPO"
              :items="types"
              @change="getStockedItems"
              v-model="stock_item_type_id"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="CATEGORIA"
              :items="categories"
              @change="getStockedItems"
              v-model="stock_item_category_id"
            />
          </b-col>
          <b-col>
            <v-text-field-default
              label="BUSCAR"
              v-model="search_stocked_items"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-overlay :show="loadingItems" opacity="0.99">
              <div
                v-show="stocked_items.length === 0"
                class="col-12 v-clean p-5"
              >
                <h6 class="text-center upper-text worksansr">
                  SEM RESULTADOS!
                </h6>
              </div>
              <div
                v-show="origin_resident_id && stocked_items.length > 0"
                class="col-12 m-0 p-0"
              >
                <p class="m-0 text-fourteen color-sysblue mb-1">
                  SÓ É POSSÍVEL REALIZAR TRANSFERÊNCIA DE LOTES QUE NÃO ESTEJAM
                  SEPARADO DO RESIDENTE SELECIONADO!
                </p>
              </div>
              <v-data-table
                v-show="stocked_items.length > 0"
                :search="search_stocked_items"
                :headers="stocked_items_headers"
                :items="stocked_items"
                :footerProps="{
                  'items-per-page-options': [5, 25, 50],
                  'items-per-page-text': 'Mostrar',
                }"
              >
                <template #item="{ item }">
                  <tr
                    :class="[
                      itemAddedToExecute(item) && 'tr-item-added-to-execute',
                    ]"
                  >
                    <td class="td-item-input-radio">
                      <p
                        class="m-0 text-center"
                        v-show="itemAddedToExecute(item)"
                      >
                        Já adicionou!
                      </p>
                      <v-radio-group
                        class="m-0 p-0"
                        v-model="selected_stocked_item_id"
                        dense
                      >
                        <v-radio
                          class="m-0 p-0"
                          :key="item.id"
                          label=""
                          :value="item"
                          v-show="!itemAddedToExecute(item)"
                        />
                      </v-radio-group>
                    </td>
                    <td item.stock_item_name>
                      {{
                        item.stock_item_type_value == "PRODUCT"
                          ? item.product_name
                          : item.medicine_name
                      }}
                    </td>
                    <td item.stock_group_name>
                      {{ item.stock_group_name }}
                    </td>
                    <td item.stock_item_type_name>
                      {{ item.stock_item_type_name }}
                    </td>
                    <td item.stock_item_category_name>
                      {{ item.stock_item_category_name }}
                    </td>
                    <td item.amount_text>
                      {{
                        item.amount.toLocaleString("pt-BR", {
                          minimumIntegerDigits: 1,
                          minimumSignificantDigits: 1,
                          minimumFractionDigits: 0,
                          maximumSignificantDigits: 10,
                          maximumFractionDigits: 10,
                          style: "decimal",
                          useGrouping: true,
                        })
                      }}
                      {{ item.stock_item_unit_of_measurement_abbreviation }}
                    </td>
                    <td item.lot>
                      {{ item.lot }}
                    </td>
                    <td item.entry_date>
                      {{ moment(item.entry_date).format("DD/MM/YYYY") }}
                    </td>
                    <td item.due_date>
                      <span
                        v-if="
                          item.due_date &&
                          item.stock_item_type_value == 'PRODUCT'
                        "
                      >
                        {{ moment(item.due_date).format("DD/MM/YYYY") }}
                      </span>
                      <span
                        v-if="
                          item.due_date &&
                          item.stock_item_type_value == 'MEDICINE'
                        "
                      >
                        {{ moment(item.due_date).format("MM/YYYY") }}
                      </span>
                      <span v-if="!item.due_date">NÃO INFORMADO</span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </b-overlay>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h4 class="title-pages">DESTINO</h4>
          </b-col>
        </b-row>
        <b-row align-v="center">
          <b-col>
            <v-select-default
              item-text="name"
              item-value="id"
              :items="residents"
              label="PROPRIETÁRIO*"
              v-model="destination_resident_id"
            />
          </b-col>
          <b-col>
            <v-select-default
              item-text="name"
              item-value="id"
              :items="destination_groups"
              label="GRUPO*"
              v-model="destination_group_id"
            />
          </b-col>
          <b-col>
            <v-text-field-default
              type="number"
              label="QUANTIDADE*"
              v-model.number="amount"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-text-field-default
              type="text"
              label="DESCRIÇÃO"
              v-model="description"
            />
          </b-col>
        </b-row>
        <warning-required-fields />
        <errors-messages :errors="create_order_errors" />
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn-add
              :disabled="btnCreateOrderDisabled"
              @click="createOrder"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="v-clean my-3">
      <b-col>
        <b-row>
          <b-col>
            <h4 class="title-pages">TRANSFERÊNCIAS</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-data-table-default
              :headers="transfer_orders_headers()"
              :items="computed_transfer_orders"
              :footerProps="{
                'items-per-page-options': [5, 25, 50],
                'items-per-page-text': 'Mostrar',
              }"
            >
              <template #[`item.amount_text`]="{ item }">
                {{ item.amount }}
                {{ item.stock_item_unit_of_measurement_abbreviation }}
              </template>
              <template #[`item.origin`]="{ item }">
                {{ item.origin_resident_name }} - {{ item.origin_group_name }}
              </template>
              <template #[`item.destination`]="{ item }">
                {{ item.destination_resident_name }} -
                {{ item.destination_group_name }}
              </template>
              <template #[`item.lot`]="{ item }">
                {{ item.lot }}
              </template>
              <template #[`item.entry_date`]="{ item }">
                {{ moment(item.entry_date).format("DD/MM/YYYY") }}
              </template>
              <template #[`item.due_date`]="{ item }">
                <span
                  v-if="
                    item.due_date && item.stock_item_type_value == 'PRODUCT'
                  "
                  >{{ moment(item.due_date).format("DD/MM/YYYY") }}</span
                >
                <span
                  v-if="
                    item.due_date && item.stock_item_type_value == 'MEDICINE'
                  "
                  >{{ moment(item.due_date).format("MM/YYYY") }}</span
                >
                <span v-if="!item.due_date">NÃO INFORMADO</span>
              </template>
              <template #[`item.actions`]="{ item }">
                <v-data-table-remove-button @click="removeOrder(item.index)" />
              </template>
            </v-data-table-default>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <errors-messages :errors="errors" />
    <b-row align-h="end">
      <b-col cols="auto">
        <v-btn-save
          :disabled="loading || computed_transfer_orders.length == 0"
          :loading="loading"
          text="EXECUTAR"
          @click="execute"
        />
      </b-col>
    </b-row>
  </tab-content-layout>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";
import TabContentLayout from "../../Components/TabContentLayout.vue";
import VBtnAdd from "../../Components/VBtnAdd.vue";
import VBtnSave from "../../Components/VBtnSave.vue";
import VDataTableDefault from "../../Components/VDataTableDefault.vue";
import VDataTableRemoveButton from "../../Components/VDataTableRemoveButton.vue";
import VSelectDefault from "../../Components/VSelectDefault.vue";
import VTextFieldDefault from "../../Components/VTextFieldDefault.vue";

import api from "../../../services/api";

import APIGet from "../../../lib/api-get";

import toast from "../../../lib/ToastNotification";

import moment from "moment";
import { localeFormat } from "../../../lib/format";
import WarningRequiredFields from "../../Components/WarningRequiredFields.vue";

export default {
  name: "Transfer",

  components: {
    TabContentLayout,
    ErrorsMessages,
    VDataTableDefault,
    VDataTableRemoveButton,
    VTextFieldDefault,
    VSelectDefault,
    VBtnAdd,
    VBtnSave,
    WarningRequiredFields,
  },

  data() {
    return {
      status_resident: "ATIVO",
      // página
      errors: [],
      loading: false,
      loadingItems: false,

      // dados
      stock_items: [],
      raw_residents: [],
      stock_groups: [],
      raw_associations: [],
      stock_item_types: [],
      stock_item_categories: [],
      stock_item_units_of_measurement: [],
      stocked_items: [],
      stocked_items_headers: [
        { text: "", value: "radio" },
        { text: "NOME", value: "stock_item_name" },
        { text: "GRUPO", value: "stock_group_name" },
        { text: "TIPO", value: "stock_item_type_name" },
        { text: "CATEGORIA", value: "stock_item_category_name" },
        { text: "QUANTIDADE", value: "amount_text" },
        { text: "LOTE", value: "lot" },
        { text: "DT/ENTRADA", value: "entry_date" },
        { text: "DT/VENCIMENTO", value: "due_date" },
      ],

      // origem
      selected_stocked_item_id: {},
      origin_resident_id: null,
      origin_group_id: "",
      stock_item_type_id: "",
      stock_item_category_id: "",
      search_stocked_items: "",
      stocked_item: [],
      amount: "",
      entry_date: moment().format("YYYY-MM-DD"),
      due_date: "",
      lot: "",
      description: "",
      create_order_errors: [],

      // destino
      destination_resident_id: null,
      destination_group_id: "",
      stock_item_unit_of_measurement_abbreviation: "",

      // ordens
      transfer_orders_base_headers: [
        { text: "ITEM", value: "stock_item_name" },
        { text: "QUANTIDADE", value: "amount_text" },
        { text: "ORIGEM", value: "origin" },
        { text: "DESTINO", value: "destination" },
        { text: "LOTE", value: "lot" },
        { text: "DT/ENTRADA", value: "entry_date" },
        { text: "DT/VENCIMENTO", value: "due_date" },
        { text: "AÇÕES", value: "actions" },
      ],
      transfer_orders: [],
    };
  },

  created() {
    this.retrieve();
  },

  computed: {
    residents() {
      return [{ id: null, name: "EMPRESA" }, ...this.raw_residents];
    },

    origin_groups() {
      return [{ id: "", name: "SELECIONE" }, ...this.stock_groups];
    },

    destination_groups() {
      let groups = [{ id: "", name: "SELECIONE" }, ...this.stock_groups];

      if (this.stocked_item.length > 0) {
        if (this.origin_resident_id == this.destination_resident_id)
          groups = groups.filter(
            (group) => group.id !== this.stocked_item[0].stock_group_id
          );

        groups = groups.filter((group) =>
          this.raw_associations.some(
            (ass) =>
              ass.stock_group_id === group.id &&
              ass.stock_item_category_id ===
                this.stocked_item[0].stock_item_category_id
          )
        );
      }

      return groups;
    },

    types() {
      return [{ id: "", name: "SELECIONE" }, ...this.stock_item_types];
    },

    categories() {
      return [{ id: "", name: "SELECIONE" }, ...this.stock_item_categories];
    },

    computed_transfer_orders() {
      return this.transfer_orders.map((transfer_order) => ({
        ...transfer_order,
        origin_resident_name: transfer_order.origin_resident_id
          ? this.residents.find(
              (resident) => resident.id === transfer_order.origin_resident_id
            ).name
          : "EMPRESA",
        origin_group_name: this.stock_groups.find(
          (group) => group.id === transfer_order.origin_group_id
        ).name,
        destination_resident_name: transfer_order.destination_resident_id
          ? this.residents.find(
              (resident) =>
                resident.id === transfer_order.destination_resident_id
            ).name
          : "EMPRESA",
        destination_group_name: this.stock_groups.find(
          (group) => group.id === transfer_order.destination_group_id
        ).name,
      }));
    },

    btnCreateOrderDisabled() {
      if (this.stocked_item.length === 0) return true;

      const stocked_item = this.stocked_item[0];

      if (!this.amount || this.amount <= 0) return true;

      if (this.amount > this.stockedItemAmountLeft(stocked_item)) return true;

      if (!this.destination_group_id) return true;

      return false;
    },
  },

  watch: {
    stocked_item() {
      if (this.stocked_item.length > 0) {
        let item = this.stocked_item[0];
        this.amount = item.amount;
        this.entry_date = moment(item.entry_date).format("YYYY-MM-DD");
        if (item.due_date) {
          this.due_date =
            item.stock_item_type_value == "PRODUCT"
              ? moment(item.due_date).format("YYYY-MM-DD")
              : moment(item.due_date).format("YYYY-MM");
        }

        this.lot = item.lot;
        this.description = item.description;
        this.stock_item_unit_of_measurement_abbreviation =
          item.stock_item_unit_of_measurement_abbreviation;
      } else {
        this.amount = "";
        this.entry_date = moment().format("YYYY-MM-DD");
        this.due_date = "";
        this.lot = "";
        this.description = "";
      }
    },

    destination_groups() {
      if (this.destination_groups.length === 0) this.destination_group_id = "";
    },

    selected_stocked_item_id() {
      if (this.selected_stocked_item_id.id) {
        this.stocked_item = [this.selected_stocked_item_id];
      } else {
        this.stocked_item = [];
      }
    },
  },

  methods: {
    moment,

    itemAddedToExecute(item) {
      let { transfer_orders } = this;

      let exist = transfer_orders.find(
        (transfer_order) => transfer_order.stocked_item_id == item.id
      );

      if (exist) {
        return true;
      }

      return false;
    },

    async retrieve() {
      if (this.errors.length === 0) this.getUnitsOfMeasurement();
      if (this.errors.length === 0) this.getResidents();
      if (this.errors.length === 0) this.getGroups();
      if (this.errors.length === 0) this.getTypes();
      if (this.errors.length === 0) this.getCategories();
      if (this.errors.length === 0) this.getStockedItems();
      if (this.errors.length === 0) this.getAssociations();
    },

    async getStockedItems() {
      this.loading = true;

      const params = {
        resident_id: this.origin_resident_id,
        stock_group_id: this.origin_group_id,
        stock_item_type_id: this.stock_item_type_id,
        stock_item_category_id: this.stock_item_category_id,
      };

      const { errors, stocked_items } = await APIGet.getStockedItems(params);

      this.errors = errors;

      let items = [];
      for (let stocked_item of stocked_items) {
        if (stocked_item.amount > 0) {
          let unit_of_measurement_abbreviation =
            stocked_item?.stock_item_unit_of_measurement?.abbreviation ?? "";

          let amount = this.stockedItemAmountLeft(stocked_item);

          let amount_text = `${localeFormat(
            amount
          )} ${unit_of_measurement_abbreviation}`;

          items.push({
            ...stocked_item,
            amount: this.stockedItemAmountLeft(stocked_item),
            amount_text,
            unit_of_measurement_abbreviation,
          });
        }
      }

      this.stocked_items = items;
      this.loading = false;
    },

    async getResidents() {
      this.loading = true;
      let { status_resident } = this;
      const { error, errors, residents } = await APIGet.getResidents({
        status_resident,
      });
      this.errors = errors;
      this.raw_residents = error ? [] : residents;
      this.loading = false;
    },

    async getGroups() {
      this.loading = true;
      const { error, errors, stock_groups } = await APIGet.getStockGroups();
      this.errors = errors;
      this.stock_groups = error ? [] : stock_groups;
      this.loading = false;
    },

    async getTypes() {
      this.loading = true;
      const { error, errors, stock_item_types } =
        await APIGet.getStockItemTypes();
      this.errors = errors;
      this.stock_item_types = error ? [] : stock_item_types;
      this.loading = false;
    },

    async getCategories() {
      this.loading = true;
      const { error, errors, stock_item_categories } =
        await APIGet.getStockItemCategories();
      this.errors = errors;

      for (let category of stock_item_categories) {
        category.name = `${category.name} (${category.stock_item_type_name})`;
      }

      this.stock_item_categories = error ? [] : stock_item_categories;
      this.loading = false;
    },

    async getUnitsOfMeasurement() {
      this.loading = true;
      const { error, errors, stock_item_units_of_measurement } =
        await APIGet.getStockItemUnitsOfMeasurement();
      this.errors = errors;
      this.stock_item_units_of_measurement = error
        ? []
        : stock_item_units_of_measurement;
      this.loading = false;
    },

    async getAssociations() {
      this.loading = true;
      const { error, errors, associations } =
        await APIGet.getStockGroupsAssociatedCategories();
      this.errors = errors;
      this.raw_associations = error ? [] : associations;
    },

    createOrder() {
      let item = this.stocked_item[0];

      let {
        amount,
        entry_date,
        due_date,
        lot,
        description,
        origin_resident_id,
        destination_resident_id,
        destination_group_id,
        stock_item_unit_of_measurement_id,
        stock_item_unit_of_measurement_abbreviation,
      } = this;

      this.transfer_orders.push({
        stock_item_id: item.stock_item_id,
        stocked_item_id: item.id,
        stock_item_name:
          item.stock_item_type_value == "PRODUCT"
            ? item.product_name
            : item.medicine_name,
        stock_item_unit_of_measurement_id,
        stocked_item_lot_id: item.stocked_item_lot_id,
        amount,
        amount_text: `${amount} ${item.unit_of_measurement_abbreviation}`,
        entry_date,
        due_date,
        lot,
        description,
        origin_resident_id,
        origin_group_id: item.stock_group_id,
        destination_resident_id,
        destination_group_id,
        stock_item_type_value: item.stock_item_type_value,
        message: "",
        stock_item_unit_of_measurement_abbreviation,
      });

      this.stocked_item = [];
      this.selected_stocked_item_id = {};
    },

    removeOrder(index) {
      this.transfer_orders.splice(index, 1);
    },

    /**
     * @param {{
     *   amount: number,
     *   id: number,
     *   multiple: number,
     *   stock_group_id: number,
     *   stock_item_category_id: number,
     *   stock_item_id: number,
     *   stock_item_type_id: number,
     * }} stocked_item
     */
    stockedItemAmountLeft(stocked_item) {
      const amount = stocked_item.amount;
      const amount_used = this.transfer_orders
        .filter((order) => order.stocked_item_id === stocked_item.id)
        .reduce((total, order) => (total += order.amount), 0);

      return amount - amount_used;
    },

    transfer_orders_headers() {
      const headers = [...this.transfer_orders_base_headers];

      if (this.transfer_orders.some((transfer_order) => transfer_order.message))
        headers.push({ text: "MENSAGEM", value: "message" });

      return headers;
    },

    async execute() {
      try {
        this.loading = true;

        const data = { transfer_orders: this.transfer_orders };
        const response = await api.post("/rest-home/stock/transfer", data);
        const { error, errors, messages, message } = response.data;

        if (error) {
          this.errors = errors;

          if (messages)
            for (const msg of messages)
              this.transfer_orders[msg.index].message = msg.message;
        } else {
          this.errors = [];
          toast(message, "success");
          this.transfer_orders = [];
          this.getStockedItems().then();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>